import { FooterCustomization, HeaderCustomization } from '@ViewModels';
import { StylePreset } from './presets';

/**
 * Applies a preset to a Header form, merging preset values with current form values.
 * Only overwrites fields that exist in the preset, preserving other form data.
 *
 * @param preset - The preset to apply
 * @param currentValues - The current form values
 * @returns Updated form values with preset applied
 */
export function applyPresetToHeaderForm(preset: StylePreset, currentValues: HeaderCustomization): HeaderCustomization {
	const updated: HeaderCustomization = { ...currentValues };
	const headerColors = preset.colors.header;

	if (headerColors) {
		updated.textColor = headerColors.textColor ?? updated.textColor;
		updated.backgroundColor = headerColors.backgroundColor ?? updated.backgroundColor;
		updated.hoverColor = headerColors.hoverColor ?? updated.hoverColor;

		if (headerColors.dropdownTextColor || headerColors.dropdownBackgroundColor) {
			updated.dropdown = {
				...updated.dropdown,
				color: headerColors.dropdownTextColor ?? updated.dropdown?.color ?? '',
				backgroundColor: headerColors.dropdownBackgroundColor ?? updated.dropdown?.backgroundColor ?? '',
				font: updated.dropdown?.font ?? { fontName: '', fontUri: '' },
			};
		}
	}

	if (preset.fonts.header) {
		updated.overallFont = preset.fonts.header;
	}

	return updated;
}

/**
 * Applies a preset to a Footer form, merging preset values with current form values.
 * Only overwrites fields that exist in the preset, preserving other form data.
 *
 * @param preset - The preset to apply
 * @param currentValues - The current form values
 * @returns Updated form values with preset applied
 */
export function applyPresetToFooterForm(preset: StylePreset, currentValues: FooterCustomization): FooterCustomization {
	const updated: FooterCustomization = { ...currentValues };
	const footerColors = preset.colors.footer;

	if (footerColors) {
		updated.backgroundColor = footerColors.backgroundColor ?? updated.backgroundColor;
		updated.textColor = footerColors.textColor ?? updated.textColor;
		updated.linkColor = footerColors.linkColor ?? updated.linkColor;
	}

	return updated;
}
